import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './slider.scss';
import './likerScaleSlider.scss';

export interface SliderProps {
    min?: number;
    max?: number;
    step?: number;
    value: number | undefined;
    onChange: (value: number | number[] | undefined) => void;
    marks: {[key: number]: string};
    disabled?: boolean;
    variant?: 'default' | 'likertScale';
}

function SliderElement({min, max, step, value, onChange, marks, disabled, variant = 'default'}: SliderProps): JSX.Element {
    const getSliderClassName = (): string => {
        const baseClass = Number.isInteger(value) ? 'rc-slider-withValue' : '';
        const variantClass = variant === 'likertScale' ? 'likert-slider' : 'default-slider';
        return `${baseClass} ${variantClass}`.trim();
    };

    return (
        <Slider
            className={getSliderClassName()}
            min={min}
            max={max}
            step={step}
            value={value}
            marks={marks}
            onChange={onChange}
            onAfterChange={onChange}
            disabled={disabled}
        />
    );
}

export default SliderElement;
